// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   API_ENDPOINT: 'https://booking-web.kz-dev.xyz/api/',
//   PUSHER_API_ENDPOINT: 'https://booking-web.kz-dev.xyz/broadcasting/auth',
//   PUSHER_APP_ID: '1928721',
//   PUSHER_APP_KEY: '03a3b387b6e724ad67e6',
//   PUSHER_SECRET_KEY: 'f52df7636d45fc248eca',
//   PUSHER_APP_CLUSTER: 'eu',
// };

export const environment = {
  production: true,
  API_ENDPOINT: 'https://api.mojrodjendan.rs/api/',
  PUSHER_API_ENDPOINT: 'https://api.mojrodjendan.rs/broadcasting/auth',
  PUSHER_APP_ID: '1937781',
  PUSHER_APP_KEY: '1981a984e513ef9d4bb8',
  PUSHER_SECRET_KEY: '32ddbbf423672b1a23c1',
  PUSHER_APP_CLUSTER: 'eu',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
